// Convertir hex a RGB
export function hexToRgb(hex) {
	let r = 0,
		g = 0,
		b = 0;
	if (hex?.length === 4) {
		r = parseInt(hex[1] + hex[1], 16);
		g = parseInt(hex[2] + hex[2], 16);
		b = parseInt(hex[3] + hex[3], 16);
	} else if (hex?.length === 7) {
		r = parseInt(hex[1] + hex[2], 16);
		g = parseInt(hex[3] + hex[4], 16);
		b = parseInt(hex[5] + hex[6], 16);
	}
	return [r, g, b];
}

/**
 * Converts a hexadecimal color value to an RGBA color value.
 *
 * @param {string} hex - The hexadecimal color code.
 * @param {number} opacity - The opacity level (0-1).
 * @returns {string} The RGBA color value.
 */
export function hexToRgba(hex, opacity) {
	let r = parseInt(hex?.slice(1, 3), 16),
		g = parseInt(hex?.slice(3, 5), 16),
		b = parseInt(hex?.slice(5, 7), 16);

	return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function darkenColor(hex, percent) {
	// Convert hex to RGB
	let r = parseInt(hex?.slice(1, 3), 16),
		g = parseInt(hex?.slice(3, 5), 16),
		b = parseInt(hex?.slice(5, 7), 16);

	// Convert RGB to HSL
	(r /= 255), (g /= 255), (b /= 255);
	let max = Math.max(r, g, b),
		min = Math.min(r, g, b);
	let h,
		s,
		l = (max + min) / 2;

	if (max === min) {
		h = s = 0;
	} else {
		let d = max - min;
		s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
		switch (max) {
			case r:
				h = (g - b) / d + (g < b ? 6 : 0);
				break;
			case g:
				h = (b - r) / d + 2;
				break;
			case b:
				h = (r - g) / d + 4;
				break;
		}
		h /= 6;
	}

	// Darken color by reducing the lightness
	l = l * (1 - percent);

	// Convert HSL back to RGB
	let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	let p = 2 * l - q;
	r = hue2rgb(p, q, h + 1 / 3);
	g = hue2rgb(p, q, h);
	b = hue2rgb(p, q, h - 1 / 3);

	// Convert RGB back to hex
	r = Math.round(r * 255).toString(16);
	g = Math.round(g * 255).toString(16);
	b = Math.round(b * 255).toString(16);

	return `#${r.padStart(2, '0')}${g.padStart(2, '0')}${b.padStart(2, '0')}`;
}

function hue2rgb(p, q, t) {
	if (t < 0) t += 1;
	if (t > 1) t -= 1;
	if (t < 1 / 6) return p + (q - p) * 6 * t;
	if (t < 1 / 2) return q;
	if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	return p;
}

// Interpolar entre dos colores
function interpolateColor(color1, color2, factor) {
	let result = [];
	for (let i = 0; i < 3; i++) {
		result[i] = Math.round(color1[i] + factor * (color2[i] - color1[i]));
	}
	return result;
}

// Convertir RGB a hex
function rgbToHex(r, g, b) {
	return (
		'#' +
		[r, g, b]
			.map(x => {
				const hex = x.toString(16);
				return hex.length === 1 ? '0' + hex : hex;
			})
			.join('')
	);
}

// Función para generar el array de colores degradados entre dos colores dados
export function generateColorGradient(steps) {
	let startColor = getComputedStyle(document.documentElement)
		.getPropertyValue('--vz-primary')
		.trim();
	let endColor = getComputedStyle(document.documentElement)
		.getPropertyValue('--vz-secondary')
		.trim();

	if (steps <= 1) {
		return [startColor, endColor];
	}

	const startRgb = hexToRgb(startColor);
	const endRgb = hexToRgb(endColor);
	let colorVariationArray = [];

	for (let i = 0; i < steps; i++) {
		const factor = i / (steps - 1);
		const interpolatedColor = interpolateColor(startRgb, endRgb, factor);
		colorVariationArray.push(rgbToHex(...interpolatedColor));
	}
	return colorVariationArray;
}

// export const ECHARTS_COLOR_PALETTE = [
// 	'#013A70',
// 	'#69B3E7',
// 	'#E56A54',
// 	'#7FA9AE',
// 	'#CCCCCC',
// 	'#7474C1',
// 	'#FFBE3D',
// 	'#00B894',
// 	'#C04ABC',
// 	'#FF6F91',
// ];

export const ECHARTS_COLOR_PALETTE = [
	'#1e344b',
	'#c77357',
	'#355774',
	'#D4A574',
	'#9697a7',
	'#1E3A8A',
	'#8B4513',
	'#FFD700',
	'#8B0000',
	'#228B22',
	'#D2691E',
];
